import { CustomerMasterSourceType } from 'generated/bffCustomer/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerInfo } from 'models/context/CustomerInfo';

export const api = {
  getCustomer: (url: string, cuRefNo: string, cpRefNo?: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/customers/${cuRefNo}`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        cpRefNo: cpRefNo,
        forceCheck: false,
      },
    }),

  updateCustomer: (url: string, cuRefNo: string, body: CustomerInfo): Promise<ExtendedAxiosResponse> =>
    apiClient.patch(`${url}/customers/${cuRefNo}`, body, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
      },
    }),

  getCustomerList: (url: string, cpRefNo?: string | null, cuRefNo?: string | null): Promise<ExtendedAxiosResponse> => {
    return apiClient.get(`${url}/context-allowed-customers`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        cpRefNo: cpRefNo,
        cuRefNo: cuRefNo,
      },
    });
  },

  postCustomerContext: (url: string, cuRefNo: string): Promise<ExtendedAxiosResponse> => {
    return apiClient.post(
      `${url}/customer-contexts`,
      {},
      {
        params: {
          channel: ChannelType.MO2_CARE,
          customerMasterSource: CustomerMasterSourceType.O2POP,
          cuRefNo: cuRefNo,
        },
      }
    );
  },
};
